

   
 
   <p-dialog [autoZIndex]='true'  appendTo="body" [baseZIndex]="99999999"  position="top"  [(visible)]="showListStands"  > 
 <h1>Liste des clients</h1>
 
     <div class="table-container mat-elevation-z8">
 
 
     <mat-form-field>
         <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
       </mat-form-field>
       
 <table mat-table #table [dataSource]="dataSource" >
     <ng-container matColumnDef="text1">
       <th mat-header-cell *matHeaderCellDef> Exposant </th>
       <td mat-cell *matCellDef="let row"> {{row.text1}} </td>
     </ng-container>
   
     <ng-container matColumnDef="text3">
         <th mat-header-cell *matHeaderCellDef> Stand </th>
         <td mat-cell *matCellDef="let row"> {{row.text3}} </td>
       </ng-container>
 
 
      
  
 
       <ng-container matColumnDef="action">
           <th mat-header-cell *matHeaderCellDef> Action </th>
           <td mat-cell *matCellDef="let row"> 
   <button mat-icon-button (click)="affectConstructeurClient(row.l1)" ><mat-icon>add_shopping_cart</mat-icon></button>
     </td>
         </ng-container>
   
     <tr mat-header-row *matHeaderRowDef="columnsToShow; sticky: true"></tr>
     <tr mat-row *matRowDef="let row; columns: columnsToShow"></tr>
   </table>
 </div>
  </p-dialog>